import React from 'react';
import './styles.scss';
import Header from '../header/Header';

const MainLayout = props => {
    const { children } = props;
    return (
        <div className="main-layout">
            <Header className="header" />
            <div className="content">{children}</div>
        </div>
    );
};

export default MainLayout;
